import { Sparkles, ChevronDown } from "lucide-react";

export default function StepQuestionStrip({ stepContext, expanded, onToggle, disabled, onSend }) {
  return (
    <div data-testid="assistant-step-strip" className="mb-2">
      <button
        type="button"
        data-testid="assistant-step-toggle"
        onClick={onToggle}
        className="flex w-full items-center justify-between text-[11px] font-bold uppercase tracking-wide text-[#1E3A8A] dark:text-blue-300"
      >
        <span className="inline-flex items-center gap-1"><Sparkles className="h-3 w-3" /> Quick questions · {stepContext.label}</span>
        <ChevronDown className={`h-3.5 w-3.5 transition-transform ${expanded ? "" : "-rotate-90"}`} />
      </button>
      {expanded && (
        <div className="mt-2 flex gap-2 overflow-x-auto pb-1">
          {stepContext.questions.map((q, i) => (
            <button
              key={q}
              type="button"
              data-testid={`assistant-step-question-${i}`}
              disabled={disabled}
              onClick={() => onSend(q)}
              className="flex-shrink-0 rounded-full border-2 border-[var(--c-border)] bg-[var(--c-bg)] px-3 py-1 text-[11px] font-semibold text-[var(--c-text)] transition-transform hover:-translate-y-0.5 disabled:opacity-40"
            >
              {q}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
